import { Component, Input } from '@angular/core';
import { TablePersonalizationService } from '../../../service/services/misc/table-personalization/table-personalization.service';

@Component({
    selector: 'app-table-personalization',
    templateUrl: './table-personalization.component.html',
    styleUrls: ['./table-personalization.component.scss'],
    standalone: false
})
export class TablePersonalizationComponent {
    constructor(private _tablePersonalizationService: TablePersonalizationService) {}
	@Input() tableKey: string;
    @Input() disabled = false;

    openTablePersonalization(): void {
	    this._tablePersonalizationService.openTablePersonalization(this.tableKey);
    }
}
